import { relativeLuminanceFromRgb } from './luminance'

/** Midpoint threshold: below this, treat page background as "dark" for contrast overrides. */
const DARK_BACKGROUND_LUMINANCE_THRESHOLD = 0.45

/**
 * @param {string|undefined} normalizedHex — six hex digits, no leading # (output of normalizeHexColor)
 * @returns {boolean}
 */
export const isDarkHexBackground = (normalizedHex) => {
  if (!normalizedHex || normalizedHex.length !== 6) return false
  const r = parseInt(normalizedHex.slice(0, 2), 16)
  const g = parseInt(normalizedHex.slice(2, 4), 16)
  const b = parseInt(normalizedHex.slice(4, 6), 16)
  if ([r, g, b].some((n) => Number.isNaN(n))) return false
  return relativeLuminanceFromRgb(r, g, b) < DARK_BACKGROUND_LUMINANCE_THRESHOLD
}
